import { PLOT_SAMPLE_RATE_RESET, PLOT_SAMPLE_RATE_UPDATE } from '../reducers/legacy/plotSampleRates';
export function updatePlotSampleRate(plotId, sampleRate) {
  return {
    type: PLOT_SAMPLE_RATE_UPDATE,
    plotId: plotId,
    sampleRate: sampleRate
  };
}
export function resetPlotSampleRates() {
  return {
    type: PLOT_SAMPLE_RATE_RESET
  };
}